const DatosArco = () => {
    return (
        <main className='container_aviso'>
            <section className='container_dat_arco'>
                <div className='container_arco'>
                    <p className='subtitle_aviso'>Medios disponibles para ejercer los derechos ARCO</p>
                    <p className='text_general'>
                        Usted, como Titular de los Datos o su representante Legal pueden ejercer en todo momento sus derechos de Acceso, Rectificación, Cancelación y
                        Oposición (en adelante "Derechos ARCO") al igual que pueden solicitar la Revocación del Consentimiento que han otorgado a Profuturo para la 
                        utilización de sus datos, a través de la Oficina de Datos Personales, correo electrónico <span className="correo_span">datospersonales@profuturo.com.mx</span><br/><br/>

                        En el caso de ejercer su derecho de Cancelación sobre el uso de sus datos personales, debe saber que puede haber situaciones en las cuales esto
                        no se realice de forma inmediata debido a alguna obligación legal que implique continuar haciendo uso de sus datos personales.<br/><br/>

                        De conformidad con la Ley, Profuturo le informará en un plazo máximo de 20 días hábiles a partir de la recepción de su solicitud si esta es
                        procedente, en su caso, esta será efectiva dentro de los 15 días hábiles siguientes a la fecha en que Profuturo emite su respuesta.<br/><br/>
                    </p>

                    <div className='divider'></div><br/>

                    <p className='subtitle_aviso'>Mecanismos para revocar su consentimiento al uso de sus datos personales</p>
                    <p className='text_general'>
                        Usted como Titular de los Datos puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de estos. Aunque es
                        posible que por alguna obligación legal requiramos seguir tratando sus datos personales. Sin embargo, le informamos que, para conocer el 
                        procedimiento y requisitos para la revocación del consentimiento, usted podrá Contactar a la Oficina de Datos Personales: correo electrónico: <span className="correo_span">datospersonales@profuturo.com.mx</span><br/><br/>

                    <div className='divider'></div><br/>

                    <h2 className='subtitle_aviso'>Opciones y medios para limitar el uso o divulgación de datos personales</h2><br />
                    <p>
                        Con el objeto de que usted pueda limitar el uso y divulgación de su información personal, en Profuturo le ofrecemos los siguientes medios:<br/><br/>
                    </p>
                        <ul>
                            <li>
                                Su inscripción en el Registro Público de Usuarios que no deseen información publicitaria de productos y servicios financieros con la 
                                finalidad de que sus datos personales no sean utilizados para recibir publicidad o promociones de empresas de bienes o servicios 
                                financieros. Para más información sobre este registro usted puede consultar el portal de internet de la CONDUSEF.
                            </li>
                            <br/>
                            <li>
                                Su registro en el listado de exclusión de Profuturo a fin de que sus datos personales no sean tratados para fines mercadotécnicos, 
                                publicitarios o de prospección comercial por nuestra parte. Para más información puede contactarse con a la Oficina de Datos Personales:
                                correo electrónico: <span className="correo_span">datospersonales@profuturo.com.mx</span><br/><br/>
                            </li>
                        </ul>
                    </p>

                    <div className='divider'></div><br/>
                </div>
            </section>
        </main>
    )
}

export default DatosArco